<template>
    <v-container class="pa-2" fluid grid-list-sm >
        <div v-if="needInit">{{initData()}}</div>
        <v-card class="shadow-none" v-if="!needInit">     
            <div v-if="getShowAnswerEvent">{{showAnswer()}}</div>
            <div v-if="getCheckAnswerEvent">{{checkAnswer()}}</div>
            <div v-if="getSaveCode">{{saveCode()}}</div>
            <div v-if="getResetTask">{{readOriginalProgram()}}</div>

            <v-toolbar dense @click="collapse = !collapse">                
                <v-icon v-if="collapse">expand_more</v-icon>
                <v-icon v-if="!collapse">chevron_right</v-icon>
                <v-toolbar-title>{{mycontent.title}} (assignment)</v-toolbar-title>
            </v-toolbar>
            <v-card class="shadow-none">
               <v-card-text>
                   <div v-if="collapse" v-html="mycontent.assignment"></div>
                </v-card-text>
            </v-card>
            <v-toolbar dense @click="collapse2 = !collapse2">                
                <v-icon v-if="collapse2">expand_more</v-icon>
                <v-icon v-if="!collapse2">chevron_right</v-icon>
                <v-toolbar-title>Preview</v-toolbar-title>
            </v-toolbar>
            <v-card class="shadow-none" v-if="showExecuteInfo">
                <v-card-text>
                    <p v-for="(rule, index) in executionResult" :key="index">
                        <v-icon v-if="rule.res" color="green">check_circle</v-icon>
                        <v-icon v-if="!rule.res"  color="red">error</v-icon>                                
                        {{rule.desc}} </p>
                </v-card-text>     
            </v-card> 

            <v-card class="shadow-none" v-if="collapse2" outlined>
               <v-card-text>
                    <iframe :srcdoc="mycontent.requestedFile" frameborder="0" width="100%">
                        <!--  <div v-if="collapse2" v-html="mycontent.requestedFile"></div>  -->
                    </iframe>
                </v-card-text>
            </v-card>

<!--             <v-card>
                <v-toolbar dense color="blue lighten-5">
                        <v-icon @click="saveCode()" style="margin:5px;" class="material-icons-outlined">cloud_upload</v-icon>
                        <v-icon @click="readOriginalProgram()" style="margin:5px;" class="material-icons-outlined">refresh</v-icon>
                        <v-spacer></v-spacer>
                        <v-btn outlined style="margin-right:50px;">{{grade}}%</v-btn>
                        <v-icon @click="showExecuteInfo = !showExecuteInfo" :color="getResultColor()" large style="magrin-right:10px;">reorder</v-icon>
                        <v-icon @click="checkAnswer()" color="green" large style="magrin-right:5px;">check_circle_outline</v-icon>
                </v-toolbar>  
  
                <div>
                <codemirror @blur="saveCode()"  class="border-top" ref="myCm1" v-model="mycontent.requestedFile"
                              :options="getCmOptions()"
                     >
                </codemirror>
                    <v-card v-if="showMyAnswer">
                        <v-toolbar dense color="blue lighten-5">                        
                            <v-toolbar-title>Authors solution:</v-toolbar-title>
                            
                            <v-spacer></v-spacer>
                        </v-toolbar>
                    </v-card>
                </div>
            </v-card> -->
                    <v-card class="shadow-none">
                     <v-toolbar dense>                
                        <v-toolbar-title>Code</v-toolbar-title>
                    </v-toolbar>
                        <div>
                                <v-layout row wrap>
                                    <v-flex :xs12="!showMyAnswer" :xs6="showMyAnswer" >

                                        <codemirror @blur="saveCode()" class="border-top" ref="myCm1" v-model="mycontent.requestedFile" 
                                                        :options="getCmOptions()"
                                                        >
                                        </codemirror>
                                    </v-flex>                                    
                                    <v-flex v-if="showMyAnswer" xs6>
                                        <h2>Answers:</h2>
                                            <codemirror class="border-top" ref="myCm2" v-model="mycontent.authorsFile" 
                                                            :options="getCmOptions()"
                                                            >
                                            </codemirror>
                                    </v-flex>
                                </v-layout>
                            
                        </div>
            </v-card>


        </v-card>
    </v-container>
</template>

<script>
import {mapGetters} from 'vuex'
// import { closeSync } from 'fs';
import { codemirror } from 'vue-codemirror'
import 'codemirror/lib/codemirror.js'
// language js
import 'codemirror/mode/javascript/javascript.js'
import 'codemirror/mode/css/css.js'
import 'codemirror/mode/xml/xml.js'
import 'codemirror/mode/htmlmixed/htmlmixed.js'
import 'codemirror/mode/python/python.js'
import 'codemirror/mode/sql/sql.js'
import 'codemirror/mode/php/php.js'
import 'codemirror/mode/clike/clike.js'

// language hint addons
import 'codemirror/addon/hint/show-hint.js'
import 'codemirror/addon/hint/show-hint.css'
import 'codemirror/addon/hint/javascript-hint.js'
import 'codemirror/addon/hint/css-hint.js'
import 'codemirror/addon/hint/xml-hint.js'
import 'codemirror/addon/hint/html-hint.js'
import 'codemirror/addon/hint/sql-hint.js'
import 'codemirror/addon/hint/anyword-hint.js'

// FULL SCREEN ADDON
import 'codemirror/addon/display/fullscreen.js'
import 'codemirror/addon/display/fullscreen.css'

  // merge css
import 'codemirror/addon/merge/merge.css'
  // merge js
import 'codemirror/addon/merge/merge.js'
import axios from './../../axios-auth'
// import configData from '../../config.js'
import * as logs from '../../assets/log_process.js'
import * as check_rules from '../../assets/check_rules.js'

export default {   
    data() {
        return {
                showExecuteInfo: false,
                executionInfo: '',
                executionResult: [],
                grade: 0,
                isRunning: false,
                task_id: 0,
                showMyAnswer: false,
                originalContent : null,
                mycontent:  {
                    title: 'loading...',
                    assignment: 'loading...',

                },
                feedback: null,
                showMyHelp: false,
                needInit : false,
                collapse: true,
                collapse2: true,
                startTime : null
        }
    },
    components :{
        codemirror
    },

    computed: 
        mapGetters([
                    'getShowAnswerEvent',
                    'getCheckAnswerEvent',
                    'getLanguageList',
                    'getSaveCode',
                    'getResetTask',
                    'getShowCompileInfo',
                    'getShowExecuteInfo',
                    ])
    ,    
    props: { 
        dcontent: Object,
        taskIndex: Number,
        activity_type: String
    },
    methods: {
        initData() {            
            this.needInit = false         
            this.$store.commit('setFeedback', null) 
            this.mycontent = this.dcontent.data.content
            this.originalContent = ""+this.mycontent.requestedFile
            this.grade = this.dcontent.score
            this.task_id = this.dcontent.task_id
            
            axios.post('/load-program3/' + this.task_id, {activity_type: this.activity_type}, this.$store.getters.getAxiosConfig )
            .then((res) => {
                const data = (res.data.code == null) ? '' : res.data.code

                if (data.length > 2) {
                    const d = JSON.parse(data)                    
                    this.mycontent.requestedFile = d[0].filecontent
                }
            })
            .catch(error => {
                this.$store.commit('setFeedback', error)
            })
        },
        saveCode() {
            const f= [{
                filename: 'index.html',                
                filecontent: this.mycontent.requestedFile
            }]
            const data = {
                task_id : this.task_id,
                activity_type: this.activity_type,
                files: JSON.stringify(f)
            }

            axios.post('/save-program3', data, this.$store.getters.getAxiosConfig )
            .then(() => {
                // set data to var
            })
            .catch(error => {
                this.$store.commit('setFeedback', error)
            })

        },
        checkAnswer() {
           this.$store.commit('setCheckAnswerEvent', false)
          
           this.prepareEvaluation()

            // send info to server
            let answerList = [ this.mycontent.requestedFile ]
            const data = {
                task_id : this.dcontent.task_id,
                time_length: Math.floor((new Date() - this.startTime)/1000 + 0.5),
                task_type_id: this.dcontent.task_type_id,
                answer_list : JSON.stringify(answerList), // my code
                description : JSON.stringify(this.executionResult)
            }
            axios.post('/task-evaluate', data, this.$store.getters.getAxiosConfig)
                .then((res) => {
                    this.useEvaluation(res.data)
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                }) 
        },        
        prepareEvaluation() {
            var _res = false
            this.executionResult = []  
            for(let i = 0; i < this.mycontent.rules_list.length; i++) {
                _res = check_rules.check_rule(this.mycontent.rules_list[i].rule_id, 
                                              this.mycontent.rules_list[i].content, 
                                              this.mycontent.requestedFile)       
                this.executionResult.push(
                    {   res: _res,
                        desc : this.mycontent.rules_list[i].description
                    })
            }  
        },
        useEvaluation(myData) {
            this.$store.commit('setWaitingForResult',false) // data was delivered
        //    this.$store.commit('setTaskRating',myData.result.rating/20) // for backdrop
            this.$store.commit('setTransferAnswer',{index: this.taskIndex, rating: myData.result.rating})
            this.$store.commit('setUserPerformance',myData.user)
            this.showExecuteInfo = true
        },           
        ///************************** */
        showAnswer() {
            this.$store.commit('setShowAnswerEvent', false)
           
            axios.get('/get-my-answer/'+this.dcontent.task_id, this.$store.getters.getAxiosConfig)
                .then((res) => {
                    this.useAnswer(res.data)
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })                                   
        },        
        useAnswer(myData) {
            const ac = JSON.parse(myData.answers)
            this.mycontent.authorsFile = ac.authorsFile
            this.$store.commit('setUserPerformance',myData.user)
            this.showMyAnswer = true // show code
        },  
        readOriginalProgram() {
            this.mycontent.requestedFile = '' + this.originalContent
        },
        getCmOptions() {
            return  {
                        tabSize: 4,
                        styleActiveLine: true,
                        lineNumbers: true,
                        line: true,
                        mode: this.$store.getters.getEditorType,
                        lineWrapping: false,
                        extraKeys: {'Ctrl-Space': 'autocomplete',
                                'F11'(cm) {
                                    cm.setOption("fullScreen", !cm.getOption("fullScreen"))
                                },
                                'Esc'(cm) {
                                if (cm.getOption("fullScreen")) cm.setOption("fullScreen", false)
                            }
                        }
                }
        },        
    },
    mounted() {
        this.needInit = true
        this.startTime = new Date()
        logs.write_to_log('open', 'course', this.dcontent.course_id, 'task', this.dcontent.task_id, 0, this.$store.getters.getAxiosConfig)
    },
    beforeDestroy() {
        logs.write_to_log('close', 'course', this.dcontent.course_id, 'task', this.dcontent.task_id, Math.floor((new Date() - this.startTime)/1000 + 0.5), this.$store.getters.getAxiosConfig)
    }
}
</script>

<style>

</style>